import { useEffect, useState } from 'react';
import { Loader } from '../Loader/Loader';

interface LazyBackgroundImageProps {
  src: string;
  alt: string;
  className?: string;
}

export const LazyBackgroundImage = ({ src, alt, className = '' }: LazyBackgroundImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsLoaded(true);
    };
  }, [src]);

  return (
    <div className="lazy-background-wrapper">
      {!isLoaded && <Loader variant="overlay" />}
      <img 
        src={src} 
        alt={alt}
        className={`${className} ${isLoaded ? 'loaded' : ''}`}
        loading="lazy"
      />
    </div>
  );
};
